import myReportsCountSlice from './slice';

export const { fetchMyReportsCount, fetchMyReportsCountError, fetchMyReportsCountSuccess } =
  myReportsCountSlice.actions;
export default myReportsCountSlice.reducer;

export * from './types';
